import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { GenericBaseService } from './generic-base.service';
import { UrlService } from "./url.service";

@Injectable({
  providedIn: 'root'
})

export class SectionService extends GenericBaseService {

  constructor(
    protected httpClient: HttpClient,
    protected toastrService: ToastrService,
    protected url: UrlService
  ) {
    super('Section', httpClient, toastrService, url);
  }
}
